<template>
    <div>
        <template v-if="reveal">
            <lessons-table-header :lessons="lessons" v-if="$store.getters['teacher/students'].length > 0">
            </lessons-table-header>
            <lessons-table v-if="$store.getters['teacher/students'].length > 0" :students="$store.getters['teacher/students']" :hover="false">
                <template v-slot:lesson="props">
                    <school-cell
                      @readonly_fail="shake_fab()"
                      :readonly="readonly"
                      :identifier="props.identifier"
                      :allowed_menu="props.lesson.allowed_menu"
                      :value="props.lesson.state"
                      @input="$store.commit('teacher/set_lesson', {lesson: $event, lesson_id: props.lesson.id, student_id: props.student.id});"
                      :dark="$vuetify.theme.dark" />
                </template>
                <template v-slot:student="props">
                    <v-badge dot overlap
                      :value="props.student.events.filter(e => ((Date.parse(e.end_date) - Date.now() > 0) && (Date.parse(e.start_date) - Date.now() < 1e3 * 60 * 60 * 24 * 7 * 2))).length"
                      :color="props.student.events.filter(e => Date.parse(e.start_date) - Date.now() <= 0).length ? 'error' : 'primary'">
                        <v-chip @click="dialog_student_id = props.student.id; student_dialog = true">{{ nameify(props.student) }}</v-chip>
                    </v-badge>
                </template>
            </lessons-table>
        </template>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
        <v-dialog v-model="student_dialog" max-width="500" :fullscreen="$vuetify.breakpoint.xs">
            <student-dialog :student_id="dialog_student_id" @change-student="id => dialog_student_id = id" mode="events" @close="student_dialog = false"/>
        </v-dialog>
        <v-dialog
          v-model="share_dialog"
          max-width="350"
        >
            <share-dialog />
        </v-dialog>
        <v-dialog
          v-model="undo_dialog"
          max-width="290"
          persistent
          >
        <undo-dialog
          @keep="undo_dialog = false;"
          @undo="get_lessons(); undo_dialog = false; readonly = true"
        />
        </v-dialog>
        <v-dialog
          v-model="leave_dialog"
          v-if="!loading"
          max-width="290"
          persistent
          >
        <leave-dialog
          @save="leave_save()"
          @discard="leave_discard()"
        />
        </v-dialog>
        <v-dialog v-model="validity_dialog" max-width="350" persistent>
            <validity-dialog
              v-model="validity"
              @close="validity_dialog = false"
            />
        </v-dialog>
        <v-progress-circular v-if="loading" :dark="$vuetify.theme.dark" indeterminate
          style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)"
        />
        <lock-speed-dial
          ref="speed_dial"
          :locked="readonly"
          :executing="fab_executing"
          :dirty="$store.getters['teacher/dirty']"
          @lock="readonly = true"
          @unlock="readonly = false"
          @save="put_lessons()"
          @undo="undo_dialog = true"
        >
            <template v-slot:actions-unlocked>
                <v-btn
                  @click="validity_dialog = true"
                  fab
                  small
                >
                    <v-icon>date_range</v-icon>
                </v-btn>
            </template>
            <template v-slot:actions-locked>
                <v-btn
                  @click="share_dialog = true"
                  fab
                  small
                >
                    <v-icon>share</v-icon>
                </v-btn>
            </template>
        </lock-speed-dial>
    </div>
</template>

<script>

import LessonsTable from './LessonsTable.vue'
import LessonsTableHeader from './LessonsTableHeader.vue'
import StudentDialog from './StudentDialog.vue'
import SchoolCell from './SchoolCell.vue'
import ValidityDialog from './ValidityDialog.vue'
import LeaveDialog from './LeaveDialog.vue'
import ShareDialog from './ShareDialog.vue'
import UndoDialog from './UndoDialog.vue'
import LockSpeedDial from './LockSpeedDial.vue'

export default {
    name: 'LessonsView',

    components: {
        LessonsTable,
        LessonsTableHeader,
        StudentDialog,
        SchoolCell,
        ValidityDialog,
        LeaveDialog,
        ShareDialog,
        UndoDialog,
        LockSpeedDial
    },

    data: () => ({

        snackbar: false,
        snackbar_msg: '',
        readonly: true,
        fab_executing: false,
        student_dialog: false,
        dialog_student_id: null,
        leave_dialog: false,
        leave_function: null,
        validity_dialog: false,
        validity: {
            start_date: null,
            end_date: null
        },
        share_dialog: false,
        undo_dialog: false,
        loading: true,
        reveal: false,

    }),
    beforeRouteLeave (from, to, next) { // eslint-disable-line no-unused-vars
        if (!this.readonly && this.$store.getters['teacher/dirty']) {
            this.leave_function = next;
            this.leave_dialog = true;
        } else if (!this.readonly && !this.$store.getters['teacher/dirty']){
            this.readonly = true;
            next();
        } else {
            next();
        }
    },
    computed: {
        lessons () {
            return this.$store.getters['teacher/lessons'];
        }
    },
    methods: {
        async get_lessons () {
            try {
                await this.$store.dispatch('teacher/get_lessons');
            } catch (e) {
                this.snackbar_msg = 'Error fetching data';
                this.snackbar = true;
            }
        },
        async put_lessons () {
            this.fab_executing = true;
            try {
                await this.$store.dispatch('teacher/put_lessons');
                this.fab_executing = false;
                this.readonly = true;
            } catch (e) {
                this.snackbar_msg = 'Error writing data';
                this.snackbar = true;
                this.fab_executing = false;
                this.shake_fab();
            }
        },
        async leave_save () {
            this.leave_dialog = false;
            await this.put_lessons();
            this.leave_function();
        },
        async leave_discard () {
            this.leave_dialog = false;
            this.get_lessons().then(() => {});
            this.readonly = true;
            this.leave_function();
        },
        shake_fab () {
            this.$refs.speed_dial.shake_fab();
        },
        nameify (student) {
            if (this.$vuetify.breakpoint.xs) {
                return student.first_name[0] + student.last_name[0];
            } else if (this.$vuetify.breakpoint.width < 1500) {
                return student.first_name.split(' ')[0] + ' ' + student.last_name[0] + '.';
            }
            return student.first_name + ' ' + student.last_name;
        }
    },
    created () {
        document.addEventListener("contextmenu", function (e) {
            e.preventDefault();
        }, false);
    },
    async mounted () {
        var self = this;
        setTimeout(async function () {
            self.reveal = true;
            self.$nextTick(function () {
                self.loading = false;
            })
        }, 0);
    }
};
</script>
